import myComputer from "../../assets/mycomputer.png";
import myDocuments from "../../assets/myDocuments.png";
import tree from "../../assets/tree.png";
import iexplorer from "../../assets/iexplorer.png";
import mspaint from "../../assets/mspaint.png";
import msdocument from "../assets/msdocument.png";
import minesweeper from "../../assets/minesweeper.png";
import bin from "../../assets/bin.png";


import TaskBar from "./desktopComponents/TaskBar";
import DesktopIcons from "./desktopComponents/DesktopIcons";
import GeneralModal from "./modal/GeneralModal";
import ModalFactory from "./modal/ModalFactory";


function Desktop() {

    let modals = ModalFactory.init();

    return (
        <div style={desktopStyle.root}>
            {/*modal components come here*/}
            <div style={desktopStyle.modals}>
                {
                    modals.map((modal) => {
                        return modal.instance; // this is the component
                    })
                }
            </div>
            <div style={desktopStyle.desk}>
                <div style={desktopStyle.iconsRoot}>
                    <DesktopIcons />
                </div>

            </div>
            <div style={desktopStyle.taskbar}>
                <TaskBar />
            </div>
        </div>
    );
}

const desktopStyle = {
    root: {
        display: "flex",
        flexDirection: "column" as "column",
        justifyContent: "flex-start",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
    },
    desk: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "flex-start",
        alignItems: "center",
        height: "calc(100vh - 50px)",
        width: "100vw",
    },
    taskbar: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: "45px",
        width: "100vw",
        position: "absolute" as "absolute",
        bottom: "0",
        zIndex: 300,
    },
    iconsRoot: {
        width: "100%",
        height: "100%",
    },
    modals: {
        position: "absolute" as "absolute",
        top: "0",
        left: "0",
        zIndex: 100,
    }
}

export default Desktop;
